import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { bandColor } from "../lib/bands";

export function ScoreDial({ score, band, size = 260, label = "Scorecaster Score" }) {
  const [display, setDisplay] = useState(0);
  const stroke = 16;
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const color = bandColor(band);
  const pct = Math.max(0, Math.min(100, score)) / 100;

  useEffect(() => {
    let raf;
    const start = performance.now();
    const duration = 1800;
    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      setDisplay(Math.round(eased * score));
      if (t < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [score]);

  return (
    <div className="relative inline-flex items-center justify-center" data-testid="score-dial" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90" aria-hidden="true">
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="#EADDCE" strokeWidth={stroke} />
        <motion.circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circumference}
          initial={{ strokeDashoffset: circumference }}
          animate={{ strokeDashoffset: circumference * (1 - pct) }}
          transition={{ duration: 1.8, ease: [0.22, 1, 0.36, 1] }}
          style={{ filter: `drop-shadow(0 0 14px ${color}40)` }}
        />
      </svg>
      <div className="absolute flex flex-col items-center">
        <span className="font-display font-extrabold leading-none tabular-nums" style={{ fontSize: size * 0.28, color }}>
          {display}
        </span>
        <span className="label-tiny mt-2" style={{ color }}>
          {band}
        </span>
        <span className="label-tiny mt-1 text-[0.55rem]">{label}</span>
      </div>
    </div>
  );
}
